import React, {useEffect, useState} from 'react';
import {get, getDatabase, ref, set} from "firebase/database";
import app from "../firebaseConfig/firebaseConfig";
import Button from "@mui/material/Button";
import {Trans} from "react-i18next";
import {useNavigate} from "react-router";
import {Box, CardContent, Paper, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import CartItemParams from "../checkout/components/CartItemParams";
import FunctionHandler from "../utils/functionHandler";
import OrderDesigns from "../user/userPage/components/OrderDesigns";
import ImageLoader from "../components/imageLoader/ImageLoader";

const db = getDatabase(app);

const cartsPath = `/carts`;
const usersPath = `/users`;

function CartsPage(props) {
    const navigate = useNavigate();
    const [carts, setCarts] = useState();
    const [userCarts, setUserCarts] = useState();
    const [openjson, setOpenjson] = useState();
    const [opened, setOpened] = useState();
    const [designsOpened, setDesignsOpened] = useState();

    function getCarts() {
        const cartsRef = ref(db, cartsPath);
        get(cartsRef).then((snapshot) => {
            const val = snapshot.val();
            setCarts(val);
        });
    }

    useEffect(() => {
        if (!db) {
            return;
        }

        getCarts();
        const usersRef = ref(db, usersPath);

        get(usersRef).then((snapshot) => {
            const users = snapshot.val();
            const uCarts = {};

            Object.keys(users || {}).forEach(uid => {
                uCarts[uid] = users[uid].cart;
            });
            setUserCarts(uCarts);
        });
    }, []);

    const sortFunction = (a, b, obj) => {
        return obj[b].lastModified - obj[a].lastModified;
    }

    const getImages = (item, product, obj) => {
        let images = product.images;

        if (product.necessaryDesigns && Number(product.necessaryDesigns)) {
            images = obj.selectedDesigns?.filter(design => design.value?.size === item.params?.size?.label).map(design => ({
                src: FunctionHandler.getFunctionUrl(`/dep/${encodeURIComponent('thumbnail/')}${design.value.src.replace(/.svg$/, '.png')}`),
                nr: design.value.nr
            }));
        }

        if (item.params?.file?.path) {
            images = [{
                src: FunctionHandler.getFunctionUrl(`/dep/${encodeURIComponent('thumbnail/')}${item.params?.file?.path.replace(/.svg$/, '.png')}`),
                nr: 1
            }];
        }

        return <OrderDesigns images={images}/>;
    }

    const deleteCart = key => {
        const cartsRef = ref(db, `${cartsPath}/${key}`);
        set(cartsRef, null);
        getCarts();
    }


    function display(obj, isDeleteable) {
        return <div>{Object.keys(obj || {}).sort((a, b) => sortFunction(a, b, obj)).map(key =>
            <div>
                <h5 onClick={() => key === openjson ? setOpenjson('') : setOpenjson(key)}>{obj[key]?.cartId}</h5>
                <div>Last mod: {new Date(obj[key]?.lastModified).toLocaleString()}</div>
                <div>{obj[key]?.invoiceData?.userInfo?.firstName} {obj[key]?.invoiceData?.userInfo?.lastName}</div>
                <div onClick={() => setDesignsOpened(key)}>Designs: {(obj[key]?.designs || []).length}</div>
                {designsOpened === key ?
                    <div style={{display: 'flex', flexWrap: 'wrap'}}>{(obj[key]?.designs || []).map((src, index) => {
                        return <Grid key={src}
                                     sx={{
                                         padding: '2px',
                                         border: '2px solid',
                                         borderColor: 'transparent'
                                     }}>
                            <Paper>
                                <ImageLoader
                                    src={FunctionHandler.getFunctionUrl(`/dep/${encodeURIComponent('thumbnail/')}${src.replace(/.svg$/, '.png')}`)}
                                    fallbackSrc={FunctionHandler.getFunctionUrl(`/dep/${src}`)}
                                    sx={{
                                        width: 50,
                                        height: 50,
                                        cursor: 'pointer'
                                    }}/>
                            </Paper>
                        </Grid>
                    })}</div> : ''}
                <div onClick={() => setOpened(key)}>Items: {Object.keys(obj[key]?.items || {}).length}</div>
                {opened === key ? <div>{Object.keys(obj[key]?.items || {}).map(itemKey => {
                    const item = obj[key]?.items[itemKey];
                    const {product} = item;
                    return <CardContent key={itemKey} sx={{pt: 0}}>
                        <Grid container>
                            <Grid flexGrow={1}>
                                <Typography variant="body1">
                                    <Trans i18nKey={product.name}/> (x{item.nr})
                                </Typography>
                                <Typography variant="caption">
                                    ({(item.discountedPrice || 0).toFixed(2)} Lei)
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="body1">
                                    {((item.discountedTotalPrice || 0)).toFixed(2)} Lei
                                </Typography>
                            </Grid>
                        </Grid>
                        {product.params ? <Box sx={{pt: 1}}>
                            <CartItemParams params={product.params} values={item.params} itemKey={key}
                                            productId={product.id} disableEdit/>
                        </Box> : ''}
                        {getImages(item, product, obj)}
                    </CardContent>
                })}</div> : ''}
                {openjson === key && <div>
                    {isDeleteable && <button onClick={() => deleteCart(key)}>Delete</button>}
                    <pre onClick={() => setOpenjson('')}>{JSON.stringify(obj[key], null, 2)}</pre>
                </div>}
            </div>
        )}</div>;
    }

    return (
        <div className="orderspage">
            <Button sx={{mt: 2}} color={'secondary'} onClick={() => navigate(-1)}>&lt; <Trans i18nKey={'buttons.back'}/></Button>
            {display(userCarts, false)}
            <br/>
            ----------------------------------------------
            <br/>
            {display(carts, true)}
        </div>
    );
}

export default CartsPage;
